import { Trophy, Film, Clapperboard, Baby, Newspaper, Radio, Music, Globe } from "lucide-react";
import { Reveal } from "./Primitives";

const categories = [
  { icon: Trophy, name: "Esportes", count: "+800 canais" },
  { icon: Film, name: "Filmes", count: "+40.000 títulos" },
  { icon: Clapperboard, name: "Séries", count: "Temporadas completas" },
  { icon: Baby, name: "Infantil", count: "Diversão para os pequenos" },
  { icon: Newspaper, name: "Notícias", count: "Cobertura 24h" },
  { icon: Radio, name: "Canais ao Vivo", count: "Abertos e fechados" },
  { icon: Music, name: "Shows & Música", count: "Ao vivo e clipes" },
  { icon: Globe, name: "Internacionais", count: "Conteúdo global" },
];

export const Channels = () => (
  <section id="canais" className="relative mx-auto max-w-7xl px-4 py-24 md:px-8 md:py-32">
    <Reveal className="mb-14 max-w-2xl">
      <span className="font-mono-accent text-xs uppercase tracking-[0.2em] text-cyan-400">// Conteúdo</span>
      <h2 className="mt-4 font-display text-3xl font-black uppercase leading-tight tracking-tighter md:text-5xl">
        Todos os canais e categorias que você ama
      </h2>
      <p className="mt-4 font-body text-slate-400">
        De esportes ao vivo a lançamentos de cinema — tudo em um só lugar, sempre atualizado.
      </p>
    </Reveal>

    <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
      {categories.map((c, i) => {
        const Icon = c.icon;
        return (
          <Reveal key={c.name} delay={i * 0.05}>
            <div
              data-testid={`channel-cat-${i}`}
              className="group relative h-full overflow-hidden rounded-2xl border border-white/8 bg-gradient-to-br from-[#0F0F1A] to-[#05050A] p-6 transition-transform duration-300 hover:-translate-y-2"
            >
              <div className="absolute -right-6 -top-6 h-20 w-20 rounded-full bg-[#8B5CF6]/0 blur-2xl transition-colors duration-300 group-hover:bg-[#8B5CF6]/30" />
              <Icon className="h-8 w-8 text-[#06B6D4] transition-colors group-hover:text-[#a78bfa]" />
              <h3 className="mt-5 font-display text-lg font-bold tracking-tight">{c.name}</h3>
              <p className="mt-1 font-mono-accent text-xs uppercase tracking-widest text-slate-500">{c.count}</p>
            </div>
          </Reveal>
        );
      })}
    </div>
  </section>
);
